import './FormsTable.css';
import { useNavigate } from 'react-router-dom';
import { LiaCheckDoubleSolid } from 'react-icons/lia';
import { LuClock } from 'react-icons/lu';
import answered from '../../assets/answered.svg';
import notAnswered from '../../assets/notAnswered.svg';
import { useTranslation } from 'react-i18next';


function FormsTable({ sessions }) {
    const navigate = useNavigate();
    const { t } = useTranslation(['player-forms']);

    return (
        <table className="webapp-forms-table">
            <thead className='webapp-forms-table-header'>
                <tr>
                    <th className='webapp-forms-table-center' >{t('Session')}</th>
                    <th className='webapp-forms-table-center'>{t('Microcycle')}</th>
                    <th className='webapp-forms-table-left' colSpan="2">{t('Session Date')}</th>
                    <th className='webapp-forms-table-left'>{t('Exercises')}</th>
                    <th className='webapp-forms-table-left' colSpan="2">{t('Forms')}</th>
                </tr>
            </thead>
            <tbody className='webapp-forms-table-body'>
                    {sessions.length === 1 && sessions[0].microcycle === -1 ?
                    <tr className='webapp-forms-table-unavailable'>
                        {t('No forms available')}
                    </tr>
                    :
                    sessions.map((session) => {
                        if (session.microcycle === -1) return null

                        const isAnyAnsweredFalse = !session.pre_train.answered || (session.post_gym.available && !session.post_gym.answered) || (session.post_train.available && !session.post_train.answered);

                        const handleButtonClick = () => {
                            const { post_gym, post_train, pre_train } = session;
                            const url = !post_gym.available
                                ? `/webapp/player/QuestionsPlayerConfirmation?ucgym=${post_gym.id}&ucgym_ans=${null}&uctrain=${post_train.id}&uctrain_ans=${null}&ucpre=${pre_train.id}&ucpre_ans=${pre_train.answered}`
                                : `/webapp/player/QuestionsPlayerConfirmation?ucgym=${post_gym.id}&ucgym_ans=${post_gym.answered}&uctrain=${post_train.id}&uctrain_ans=${post_train.answered}&ucpre=${pre_train.id}&ucpre_ans=${pre_train.answered}`;
                    
                            // Use navigate to go to the new route with the parameters
                            navigate(url);
                        }

                        const status = (
                            session.completed === true ? (
                                <span className='completed-box-formstable'>
                                    <LiaCheckDoubleSolid /> {t('Completed')}
                                </span>
                            ) : (
                                <span className='ongoing-box-formstable'>
                                    <LuClock /> {t('On Going')}
                                </span>
                            )
                        )

                        return(
                        <tr className='webapp-forms-table-body-row'>
                            <td className='webapp-forms-table-center'>{session.session}</td>
                            <td className='webapp-forms-table-center'>{session.microcycle}</td>
                            <td className='webapp-forms-table-left'>
                                {session.date}
                            </td>
                            <td className='webapp-forms-table-left'>
                                {status}
                            </td>
                            <td className='webapp-forms-table-left'>
                                {session.training_plan}
                            </td>
                            <td className='webapp-forms-table-left'>
                                <div className="webapp-forms-table-answers-values">
                                    <div className="webapp-forms-page-player-answers-row">
                                        <img src={session.pre_train.answered ? answered : notAnswered} alt="Pre-Training" />
                                        <div className={session.pre_train.answered ? "webapp-forms-page-player-row-info-answers-answered" : "webapp-forms-page-player-row-info-answers-not-answered"}>
                                            {t('Pre-Training')}
                                        </div>
                                    </div>
                                    {session.post_gym.available && (
                                        <div className="webapp-forms-page-player-answers-row">
                                            <img src={session.post_gym.answered ? answered : notAnswered} alt="Pre-Training" />
                                            <div className={session.post_gym.answered ? "webapp-forms-page-player-row-info-answers-answered" : "webapp-forms-page-player-row-info-answers-not-answered"}>
                                                {t('Post-Gym')}
                                            </div>
                                        </div>)
                                    }
                                    {session.post_train.available && (
                                        <div className="webapp-forms-page-player-answers-row">
                                            <img src={session.post_train.answered ? answered : notAnswered} alt="Pre-Training" />
                                            <div className={session.post_train.answered ? "webapp-forms-page-player-row-info-answers-answered" : "webapp-forms-page-player-row-info-answers-not-answered"}>
                                                {t('Post-Training')}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </td>
                            <td className='webapp-forms-table-center'>
                                {isAnyAnsweredFalse && <button className="webapp-forms-table-button" onClick={handleButtonClick}>
                                    {t('Answer')}
                                </button>}
                            </td>
                        </tr>
                    )})}
            </tbody>
        </table>
    );
}

export default FormsTable;
